import { render } from "./FormBuilderRespostas.vue?vue&type=template&id=c9b77502"
import script from "./FormBuilderRespostas.vue?vue&type=script&lang=js"
export * from "./FormBuilderRespostas.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__